import url from './url';

export const REGISTRATION_TIMEOUT_MS = 20000;
export const REGISTRATION_TIMEOUT_MESSAGE = 'Request timed out; your account may have been created. Try signing in using your email and password before taking any further action.';

export async function registerAccount(accountData, { timeoutMs = REGISTRATION_TIMEOUT_MS } = {}) {
    const controller = new AbortController();
    let timeoutId;
    let timedOut = false;
    const timeout = new Promise((_, reject) => {
        timeoutId = setTimeout(() => {
            timedOut = true;
            controller.abort();
            reject(new Error(REGISTRATION_TIMEOUT_MESSAGE));
        }, timeoutMs);
    });

    try {
        const request = fetch(`${url}/api/register`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(accountData),
            signal: controller.signal,
        });
        const response = await Promise.race([request, timeout]);
        const data = await Promise.race([response.json(), timeout]);

        if (!response.ok) {
            const message = data?.message || data?.error || `We could not create your account (HTTP ${response.status}).`;
            if (/already exists|already registered|email.{0,30}(exists|registered)|duplicate/i.test(message)) {
                throw new Error(`${message} Please sign in instead.`);
            }
            throw new Error(message);
        }

        return data;
    } catch (error) {
        if (timedOut) {
            throw new Error(REGISTRATION_TIMEOUT_MESSAGE);
        }
        throw error;
    } finally {
        clearTimeout(timeoutId);
    }
}